var map = {
	"./001-Lionshead.png": 63,
	"./002-Dirty D 2.png": 64,
	"./003-baie_de_beauport_6.jpeg": 65,
	"./005-Lonestar Texas Grill.png": 66,
	"./006-Boston Pizza Huntsville.jpeg": 67,
	"./007-Earls Yaletown.jpeg": 68,
	"./008-Heart and Crown.png": 69,
	"./009-ptit-caribou_ext-m.jpeg": 70,
	"./010-The Growling Gator.png": 71,
	"./011-score on king.jpeg": 72,
	"./012-Brother's Tavern.png": 73,
	"./013-The Cambie.png": 74,
	"./014-Regulars Bar.png": 75,
	"./015-Joe Dogs.jpeg": 76,
	"./016-Cabana.png": 77,
	"./017-C.P.R. Tavern.jpg": 78,
	"./019-Cabot Links.jpg": 79,
	"./020-Salt Yard.jpg": 80,
	"./022-Golf de i'lile de Montreal.jpg": 81,
	"./023-Cecile et Ramone.png": 82,
	"./024-Cafe Quatre Jeudis.jpg": 83,
	"./025-Restaurant Marina Boucherville.jpg": 84,
	"./026-Annies Sur Le Lac.jpg": 85,
	"./027-Restaurant Cabaret Liquor Store.png": 86,
	"./028-Delice Resto Lounge.jpg": 87,
	"./029-Crazy Cactus.png": 88,
	"./030-Rose & Crown.png": 89,
	"./031-The Drake - Canmore.png": 90,
	"./032-The Porch.jpg": 91,
	"./034-Lonestar - Ottawa George St..png": 92,
	"./035-Greta YEG.jpg": 93,
	"./036-greta alberta.jpg": 94,
	"./037-boston pizza - gravenhurst.jpg": 95,
	"./038-REC ROOM - toronto.png": 96,
	"./039-Jakes on Main.jpg": 97,
	"./040-La Cage.png": 98,
	"./041-St. Hubert.jpg": 99,
	"./042-Sunnyside Pavillion.jpg": 100,
	"./043-Beaver & Bulldog.jpg": 101,
	"./044-Two Amigos.jpeg": 102,
	"./045-Los Puntos Cantina.jpg": 103,
	"./046-Banditos.png": 104,
	"./047-The Slip.png": 105,
	"./048-On The Docks.jpeg": 106,
	"./049-RIkochez.png": 107,
	"./050-Abbey Road Taphousejpeg.jpeg": 108,
	"./051-Ocean Park Pub.jpg": 109,
	"./052-Legends Neighbourhood Pub.jpeg": 110,
	"./053-Marr Hotel.jpg": 111,
	"./054-Ceilis.jpg": 112,
	"./055-Paddy Flahertys.png": 113,
	"./056-Grogs.png": 114,
	"./057-le quartier General.jpg": 115,
	"./058-The Lazy Flamingo.png": 116,
	"./059-Delta - SOCO Kitchen.png": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;